import { render, staticRenderFns } from "./animated_number.vue?vue&type=template&id=74222012"
import script from "./animated_number.vue?vue&type=script&lang=js"
export * from "./animated_number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports